import { render } from "./VideoGalleryAddPage.vue?vue&type=template&id=182d90bb&scoped=true"
import script from "./VideoGalleryAddPage.vue?vue&type=script&lang=js"
export * from "./VideoGalleryAddPage.vue?vue&type=script&lang=js"

import "./VideoGalleryAddPage.vue?vue&type=style&index=0&id=182d90bb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182d90bb"]])

export default __exports__